import * as React from 'react';
import { AuthContext } from 'domain/auth/contexts/AuthProvider';

function useAuthContext() {
  return React.useContext(AuthContext);
}

export { useAuthContext };
